import FieldQty from './FieldQty'

export default FieldQty
